export const ExperimentsConsts = {
  AlwaysShowComplexPhoneField: 'specs.bookings.AlwaysShowComplexPhoneField',
  FixFormUoUCheckboxLink: 'specs.bookings.FixFormUoUCheckboxLink',
  Cart: 'specs.bookings.cart',
  HideCouponInFormPage: 'specs.bookings.HideCouponInFormPage',
  SendAddressToEcomCheckoutAndCart:
    'specs.bookings.sendAddressToEcomCheckoutAndCart',
  ChangePricingPlanNavigationToNewApi:
    'specs.bookings.ChangePricingPlanNavigationToNewApi',
  HidePriceWhenBuyinAPlanInDynamicPriceDropdown:
    'specs.bookings.HidePriceWhenBuyinAPlanInDynamicPriceDropdown',
  AppSectionParamsAdapter: 'specs.bookings.AppSectionParamsAdapter',
  BookingsFormWidgetCssOptimization:
    'specs.bookings.BookingsFormWidgetCssOptimization',
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  AwaitForPPNavigation: 'specs.bookings.AwaitForPPNavigation',
  AddTimeZoneToContactDetails: 'specs.bookings.AddTimeZoneToContactDetails',
  PreventConflictsOnCart: 'specs.bookings.PreventConflictsOnCart',
  DisableFormValidationWhenPurchasingAPricingPlan:
    'specs.bookings.DisableFormValidationWhenPurchasingAPricingPlan',
  DeleteFullAddressFromCollapseFormValues:
    'specs.bookings.DeleteFullAddressFromCollapseFormValues',
  MultiServiceAppointment: 'specs.bookings.multiServiceAppointment',
  FormPaymentOptionNewDropdown: 'specs.bookings.FormPaymentOptionNewDropdown',
  AddShouldCallConsistantQueryToGetScheduleAvailability:
    'specs.bookings.AddShouldCallConsistantQueryToGetScheduleAvailability',
  queryServiceOptionsAndVariants:
    'specs.bookings.queryServiceOptionsAndVariants',
  SplitJapaneseNamesOnForm: 'specs.bookings.SplitJapaneseNamesOnForm',
  AdditionalTimeSlotsInFormPlugin:
    'specs.bookings.AdditionalTimeSlotsInFormPlugin',
};
